var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('calendar-app',{attrs:{"eventos":_vm.eventos},on:{"clicked":_vm.openModalCadastro,"event-clicked":_vm.visualizar,"update":_vm.updateData}}),_vm._v(" "),_c('ModalCadastrar',{attrs:{"data":_vm.dataSelected},on:{"store":_vm.cadastrar}}),_vm._v(" "),_c('ModalShow',{attrs:{"evento":_vm.eventoSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }